tailwind.config = {
  darkMode: "class",
  theme: {
    extend: {
      colors: {
        "error": "#ba1a1a",
        "on-secondary-fixed-variant": "#9a3412",
        "surface-dim": "#f1f5f9",
        "primary-fixed-dim": "#95d4b3",
        "primary-fixed": "#b1f0ce",
        "on-surface-variant": "#404943",
        "secondary": "#c85a17",
        "on-surface": "#0f172a",
        "on-secondary-container": "#7c2d12",
        "error-container": "#ffdad6",
        "tertiary-fixed": "#92f7c3",
        "tertiary": "#005236",
        "inverse-primary": "#95d4b3",
        "on-secondary-fixed": "#431407",
        "surface-bright": "#ffffff",
        "surface-container-highest": "#cbd5e1",
        "surface-container-lowest": "#ffffff",
        "primary": "#0f5238",
        "outline-variant": "#bfc9c1",
        "secondary-fixed": "#ffedd5",
        "on-tertiary-container": "#89edba",
        "inverse-surface": "#1e293b",
        "surface-container-high": "#e2e8f0",
        "on-error-container": "#93000a",
        "on-primary-container": "#a8e7c5",
        "on-tertiary": "#ffffff",
        "on-tertiary-fixed-variant": "#005235",
        "tertiary-container": "#006d48",
        "background": "#ffffff",
        "surface-container": "#f1f5f9",
        "primary-container": "#2d6a4f",
        "tertiary-fixed-dim": "#75daa8",
        "on-primary": "#ffffff",
        "surface": "#ffffff",
        "on-primary-fixed": "#002114",
        "on-secondary": "#ffffff",
        "secondary-container": "#fed7aa",
        "on-tertiary-fixed": "#002113",
        "on-error": "#ffffff",
        "surface-container-low": "#f8fafc",
        "on-background": "#0f172a",
        "surface-variant": "#cbd5e1",
        "surface-tint": "#2c694e",
        "on-primary-fixed-variant": "#0e5138",
        "inverse-on-surface": "#ffffff",
        "secondary-fixed-dim": "#fed7aa",
        "outline": "#707973"
      },
      borderRadius: {
        "DEFAULT": "0.25rem",
        "lg": "0.5rem",
        "xl": "0.75rem",
        "2xl": "1rem",
        "full": "9999px"
      },
      fontFamily: {
        "body-sm": ["Plus Jakarta Sans", "sans-serif"],
        "label-lg": ["Plus Jakarta Sans", "sans-serif"],
        "body-lg": ["Plus Jakarta Sans", "sans-serif"],
        "display-lg-mobile": ["Newsreader", "serif"],
        "title-md": ["Plus Jakarta Sans", "sans-serif"],
        "body-md": ["Plus Jakarta Sans", "sans-serif"],
        "headline-xl": ["Newsreader", "serif"],
        "label-md": ["Plus Jakarta Sans", "sans-serif"],
        "headline-sm": ["Newsreader", "serif"],
        "headline-lg": ["Newsreader", "serif"],
        "headline-xl-mobile": ["Newsreader", "serif"],
        "display-lg": ["Newsreader", "serif"],
        "label-sm": ["Plus Jakarta Sans", "sans-serif"],
        "headline-md": ["Newsreader", "serif"]
      }
    }
  }
};
